<script lang="ts">
  interface Props {
    titleTestId?: string;
    paragraphTestId?: string;
    image?: import('svelte').Snippet;
    title?: import('svelte').Snippet;
    paragraph?: import('svelte').Snippet;
    action?: import('svelte').Snippet;
  }

  let { titleTestId = '', paragraphTestId = '', image, title, paragraph, action }: Props = $props();
</script>

<div class="grid w-full place-items-center content-start overflow-hidden bg-background-subtle">
  {@render image?.()}
</div>
<div class="p-6">
  <p class="typography-h5-semibold mb-2" data-testId={titleTestId}>
    {@render title?.()}
  </p>
  <p data-testId={paragraphTestId}>
    {@render paragraph?.()}
  </p>
  <div class="relative z-10 mt-4 grid gap-3">
    {@render action?.()}
  </div>
</div>
